import React, { useEffect } from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { useThemeMode } from '../../ThemeContext';
import Checkmark from '../../assets/checkmark.svg';
import '../StripePayment/StripePayment.css';
import '../../styles/login.css';
import ContactUsForm from './ContactUsForm';
import CloseIcon from '@mui/icons-material/Close';
import LogoSvg from '../../assets/logo.svg';

function Enquiry() {
  const { mode } = useThemeMode();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    document.body.classList.remove('dark-mode', 'light-mode');
    document.body.classList.add(mode === 'dark' ? 'dark-mode' : 'light-mode');
  }, [mode]);

  const handleSuccess = () => {
    // Success is now handled by ContactUsForm component
  };

  // Optional plan title passed via navigation state
  const planTitle = location.state?.planTitle || 'Enterprise Plan';

  return (
    <div className={`login-body ${mode === 'dark' ? 'dark-mode' : 'light-mode'}`} style={{ overflowX: 'hidden', overflowY: 'auto' }}>
      {/* Header with Logo, Title and Close Button */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        padding: '16px 24px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: mode === 'dark' ? 'rgba(17, 17, 17, 0.9)' : 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(10px)',
        borderBottom: `1px solid ${mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`
      }}>
        {/* Logo on left */}
        <Link to="/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', flex: '0 0 auto' }}>
          <img src={LogoSvg} alt="Complimate Logo" style={{ height: 40, verticalAlign: 'middle' }} />
        </Link>
        
        {/* Title centered */}
        <h2 style={{
          margin: 0,
          fontSize: '24px',
          fontWeight: 700,
          color: mode === 'dark' ? '#26C3C0' : '#009391',
          fontFamily: "'Urbanist', Arial, sans-serif",
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          whiteSpace: 'nowrap'
        }}>
          Contact Us
        </h2>
        
        {/* Close button on right */}
        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '50%',
            color: mode === 'dark' ? '#FFFFFF' : '#222222',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background-color 0.2s ease',
            flex: '0 0 auto',
            marginLeft: 'auto'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = mode === 'dark' ? '#333' : '#f0f0f0';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'transparent';
          }}
        >
          <CloseIcon style={{ fontSize: '24px' }} />
        </button>
      </div>

      <Container fluid className="login-container" style={{ paddingTop: '80px' }}>
        <Row className="g-0" style={{ minHeight: '100vh' }}>
          {/* Left Side - Plan Title + Features */}
          <Col lg={6} className="d-none d-lg-block position-relative" style={{ display: 'block' }}>
            <div className="plan-details-section" style={{ padding: 24 }}>
              <div className="checkout-header" style={{ marginBottom: 8 }}>
                <h2 className="checkout-title" style={{ color: '#26C3C0' }}>{planTitle}</h2>
              </div>

              {/* Plan Features (if provided via navigation state) */}
              {location.state?.formattedDescription && (
                <div className="features-preview" style={{ marginTop: 8 }}>
                  <h5 className="features-title">Plan Features:</h5>
                  <ul className="plan-features">
                    {location.state.formattedDescription.split('\n').map((line, index) => {
                      if (index === 0) return null;
                      if (!line.trim()) return null;
                      return (
                        <li key={index} className="feature-item">
                          <img src={Checkmark} className="feature-check" alt="check" />
                          <span>{line.trim()}</span>
                        </li>
                      );
                    }).filter(Boolean)}
                  </ul>
                </div>
              )}
            </div>
          </Col>

          {/* Right Side - Enquiry Form (aligned with Plan title) */}
          <Col xs={12} lg={6} className="d-flex align-items-start justify-content-center position-relative">
            <div className="login-blur-bg-top"></div>
            <div className="login-blur-bg-bottom"></div>
            <div className="login-form-wrapper w-100" style={{ maxWidth: '486px', paddingTop: '24px' }}>
              <ContactUsForm 
                submitLabel="Submit Enquiry" 
                onSuccess={handleSuccess}
                secondaryFirst={true}
                secondaryAction={
                  <Button 
                    variant="outline-secondary" 
                    className="action-btn secondary-action"
                    style={{ whiteSpace: 'nowrap' }}
                    onClick={() => navigate(-1)}
                  >
                    Go Back
                  </Button>
                }
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Enquiry;


